import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, InjectionToken, inject, input, computed, EventEmitter, signal, booleanAttribute, ContentChildren, ContentChild, Output, Input, ViewEncapsulation, ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { SharedModule, PrimeTemplate } from 'primeng/api';
import { BaseComponent, PARENT_INSTANCE } from 'primeng/basecomponent';
import * as i1 from 'primeng/bind';
import { Bind } from 'primeng/bind';
import { TimesIcon } from 'primeng/icons';
import { MotionModule } from 'primeng/motion';
import { Ripple } from 'primeng/ripple';
import { style } from '@primeuix/styles/message';
import { BaseStyle } from 'primeng/base';
const _c0 = ["container"];
const _c1 = ["icon"];
const _c2 = ["closeicon"];
const _c3 = ["*"];
const _c4 = a0 => ({
  closeCallback: a0
});
function Message_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Message_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Message_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.iconTemplate || ctx_r0._iconTemplate);
  }
}
function Message_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.cn(ctx_r0.cx("icon"), ctx_r0.icon));
    i0.ɵɵproperty("pBind", ctx_r0.ptm("icon"));
    i0.ɵɵattribute("data-p", ctx_r0.dataP);
  }
}
function Message_Conditional_4_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Message_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Message_Conditional_4_ng_container_0_Template, 1, 0, "ng-container", 5);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.containerTemplate || ctx_r0._containerTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c4, ctx_r0.closeCallback));
  }
}
function Message_Conditional_5_div_0_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("pBind", ctx_r0.ptm("text"))("ngClass", ctx_r0.cx("text"))("innerHTML", ctx_r0.text, i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("data-p", ctx_r0.dataP);
  }
}
function Message_Conditional_5_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, Message_Conditional_5_div_0_span_1_Template, 1, 4, "span", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.escape);
  }
}
function Message_Conditional_5_ng_template_1_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("pBind", ctx_r0.ptm("text"))("ngClass", ctx_r0.cx("text"));
    i0.ɵɵattribute("data-p", ctx_r0.dataP);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.text);
  }
}
function Message_Conditional_5_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Message_Conditional_5_ng_template_1_span_0_Template, 2, 4, "span", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r0.escape && ctx_r0.text);
  }
}
function Message_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Message_Conditional_5_div_0_Template, 2, 1, "div", 6)(1, Message_Conditional_5_ng_template_1_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(3, "span", 7);
    i0.ɵɵprojection(4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const escapeOut_r2 = i0.ɵɵreference(2);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r0.escape)("ngIfElse", escapeOut_r2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("pBind", ctx_r0.ptm("text"))("ngClass", ctx_r0.cx("text"));
    i0.ɵɵattribute("data-p", ctx_r0.dataP);
  }
}
function Message_Conditional_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r0.cn(ctx_r0.cx("closeIcon"), ctx_r0.closeIcon));
    i0.ɵɵproperty("pBind", ctx_r0.ptm("closeIcon"))("ngClass", ctx_r0.closeIcon);
    i0.ɵɵattribute("data-p", ctx_r0.dataP);
  }
}
function Message_Conditional_6_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Message_Conditional_6_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Message_Conditional_6_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.closeIconTemplate || ctx_r0._closeIconTemplate);
  }
}
function Message_Conditional_6_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 14);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r0.cx("closeIcon"));
    i0.ɵɵproperty("pBind", ctx_r0.ptm("closeIcon"));
    i0.ɵɵattribute("data-p", ctx_r0.dataP);
  }
}
function Message_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function Message_Conditional_6_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.close($event));
    });
    i0.ɵɵconditionalCreate(1, Message_Conditional_6_Conditional_1_Template, 1, 5, "i", 12);
    i0.ɵɵconditionalCreate(2, Message_Conditional_6_Conditional_2_Template, 1, 1, "ng-container");
    i0.ɵɵconditionalCreate(3, Message_Conditional_6_Conditional_3_Template, 1, 4, ":svg:svg", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.cx("closeButton"));
    i0.ɵɵproperty("pBind", ctx_r0.ptm("closeButton"));
    i0.ɵɵattribute("aria-label", ctx_r0.closeAriaLabel)("data-p", ctx_r0.dataP);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.closeIcon ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.closeIconTemplate || ctx_r0._closeIconTemplate ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.closeIconTemplate && !ctx_r0._closeIconTemplate && !ctx_r0.closeIcon ? 3 : -1);
  }
}
const classes = {
  root: ({
    instance
  }) => ['p-message p-component p-message-' + instance.severity, instance.variant && 'p-message-' + instance.variant, {
    'p-message-sm': instance.size === 'small',
    'p-message-lg': instance.size === 'large'
  }],
  contentWrapper: 'p-message-content-wrapper',
  content: 'p-message-content',
  icon: 'p-message-icon',
  text: 'p-message-text',
  closeButton: 'p-message-close-button',
  closeIcon: 'p-message-close-icon'
};
let MessageStyle = /*#__PURE__*/(() => {
  class MessageStyle extends BaseStyle {
    name = 'message';
    style = style;
    classes = classes;
    static ɵfac = /* @__PURE__ */(() => {
      let ɵMessageStyle_BaseFactory;
      return function MessageStyle_Factory(__ngFactoryType__) {
        return (ɵMessageStyle_BaseFactory || (ɵMessageStyle_BaseFactory = i0.ɵɵgetInheritedFactory(MessageStyle)))(__ngFactoryType__ || MessageStyle);
      };
    })();
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MessageStyle,
      factory: MessageStyle.ɵfac
    });
  }
  return MessageStyle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 *
 * Message groups a collection of contents in tabs.
 *
 * [Live Demo](https://www.primeng.org/message/)
 *
 * @module messagestyle
 *
 */
var MessageClasses = /*#__PURE__*/function (MessageClasses) {
  /**
   * Class name of the root element
   */
  MessageClasses["root"] = "p-message";
  /**
   * Class name of the content element
   */
  MessageClasses["content"] = "p-message-content";
  /**
   * Class name of the icon element
   */
  MessageClasses["icon"] = "p-message-icon";
  /**
   * Class name of the text element
   */
  MessageClasses["text"] = "p-message-text";
  /**
   * Class name of the close button element
   */
  MessageClasses["closeButton"] = "p-message-close-button";
  /**
   * Class name of the close icon element
   */
  MessageClasses["closeIcon"] = "p-message-close-icon";
  return MessageClasses;
}(MessageClasses || {});
const MESSAGE_INSTANCE = /*#__PURE__*/new InjectionToken('MESSAGE_INSTANCE');
/**
 * Message groups a collection of contents in tabs.
 * @group Components
 */
let Message = /*#__PURE__*/(() => {
  class Message extends BaseComponent {
    componentName = 'Message';
    _componentStyle = inject(MessageStyle);
    bindDirectiveInstance = inject(Bind, {
      self: true
    });
    $pcMessage = inject(MESSAGE_INSTANCE, {
      optional: true,
      skipSelf: true
    }) ?? undefined;
    onAfterViewChecked() {
      this.bindDirectiveInstance.setAttrs(this.ptms(['host', 'root']));
    }
    /**
     * Severity level of the message.
     * @defaultValue 'info'
     * @group Props
     */
    severity = 'info';
    /**
     * Text content.
     * @deprecated since v20.0.0. Use content projection instead '<p-message>Content</p-message>'.
     * @group Props
     */
    text;
    /**
     * Whether displaying messages would be escaped or not.
     * @deprecated since v20.0.0. Use content projection instead '<p-message>Content</p-message>'.
     * @group Props
     */
    escape = true;
    /**
     * Inline style of the component.
     * @group Props
     */
    style;
    /**
     * Style class of the component.
     * @group Props
     */
    styleClass;
    /**
     * Whether the message can be closed manually using the close icon.
     * @group Props
     * @defaultValue false
     */
    closable = false;
    /**
     * Icon to display in the message.
     * @group Props
     * @defaultValue undefined
     */
    icon;
    /**
     * Icon to display in the message close button.
     * @group Props
     * @defaultValue undefined
     */
    closeIcon;
    /**
     * Delay in milliseconds to close the message automatically.
     * @defaultValue undefined
     */
    life;
    /**
     * Transition options of the show animation.
     * @defaultValue '300ms ease-out'
     * @group Props
     * @deprecated since v21.0.0, use `motionOptions` instead.
     */
    showTransitionOptions = '300ms ease-out';
    /**
     * Transition options of the hide animation.
     * @defaultValue '200ms cubic-bezier(0.86, 0, 0.07, 1)'
     * @group Props
     * @deprecated since v21.0.0, use `motionOptions` instead.
     */
    hideTransitionOptions = '200ms cubic-bezier(0.86, 0, 0.07, 1)';
    /**
     * Defines the size of the component.
     * @group Props
     */
    size;
    /**
     * Specifies the input variant of the component.
     * @group Props
     */
    variant;
    /**
     * The motion options.
     * @group Props
     */
    motionOptions = input(undefined, ...(ngDevMode ? [{
      debugName: "motionOptions"
    }] : []));
    computedMotionOptions = computed(() => {
      return {
        ...this.ptm('motion'),
        ...this.motionOptions()
      };
    }, ...(ngDevMode ? [{
      debugName: "computedMotionOptions"
    }] : []));
    /**
     * Emits when the message is closed.
     * @param {{ originalEvent: Event }} event - The event object containing the original event.
     * @group Emits
     */
    onClose = new EventEmitter();
    get closeAriaLabel() {
      return this.config.translation.aria ? this.config.translation.aria.close : undefined;
    }
    visible = signal(true, ...(ngDevMode ? [{
      debugName: "visible"
    }] : []));
    /**
     * Custom template of the message container.
     * @param {MessageContainerTemplateContext} context - container context.
     * @see {@link MessageContainerTemplateContext}
     * @group Templates
     */
    containerTemplate;
    /**
     * Custom template of the message icon.
     * @group Templates
     */
    iconTemplate;
    /**
     * Custom template of the close icon.
     * @group Templates
     */
    closeIconTemplate;
    templates;
    _containerTemplate;
    _iconTemplate;
    _closeIconTemplate;
    closeCallback = event => {
      this.close(event);
    };
    onInit() {
      if (this.life) {
        setTimeout(() => {
          this.visible.set(false);
        }, this.life);
      }
    }
    onAfterContentInit() {
      this.templates?.forEach(item => {
        switch (item.getType()) {
          case 'container':
            this._containerTemplate = item.template;
            break;
          case 'icon':
            this._iconTemplate = item.template;
            break;
          case 'closeicon':
            this._closeIconTemplate = item.template;
            break;
        }
      });
    }
    /**
     * Closes the message.
     * @param {Event} event - Browser event.
     * @group Method
     */
    close(event) {
      this.visible.set(false);
      this.onClose.emit({
        originalEvent: event
      });
    }
    get dataP() {
      return this.cn({
        outlined: this.variant === 'outlined',
        simple: this.variant === 'simple',
        [this.severity]: this.severity,
        [this.size]: this.size
      });
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵMessage_BaseFactory;
      return function Message_Factory(__ngFactoryType__) {
        return (ɵMessage_BaseFactory || (ɵMessage_BaseFactory = i0.ɵɵgetInheritedFactory(Message)))(__ngFactoryType__ || Message);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: Message,
      selectors: [["p-message"]],
      contentQueries: function Message_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, _c0, 4)(dirIndex, _c1, 4)(dirIndex, _c2, 4)(dirIndex, PrimeTemplate, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.containerTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.iconTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.closeIconTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
        }
      },
      hostAttrs: ["role", "alert", "aria-live", "polite"],
      hostVars: 5,
      hostBindings: function Message_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵanimateEnter(function Message_HostBindings_animateenter_cb() {
            return "p-message-enter-active";
          });
          i0.ɵɵanimateLeave(function Message_HostBindings_animateleave_cb() {
            return "p-message-leave-active";
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("data-p", ctx.dataP);
          i0.ɵɵclassMap(ctx.cn(ctx.cx("root"), ctx.styleClass));
          i0.ɵɵclassProp("p-message-leave-active", !ctx.visible());
        }
      },
      inputs: {
        severity: "severity",
        text: "text",
        escape: [2, "escape", "escape", booleanAttribute],
        style: "style",
        styleClass: "styleClass",
        closable: [2, "closable", "closable", booleanAttribute],
        icon: "icon",
        closeIcon: "closeIcon",
        life: "life",
        showTransitionOptions: "showTransitionOptions",
        hideTransitionOptions: "hideTransitionOptions",
        size: "size",
        variant: "variant",
        motionOptions: [1, "motionOptions"]
      },
      outputs: {
        onClose: "onClose"
      },
      features: [i0.ɵɵProvidersFeature([MessageStyle, {
        provide: MESSAGE_INSTANCE,
        useExisting: Message
      }, {
        provide: PARENT_INSTANCE,
        useExisting: Message
      }]), i0.ɵɵHostDirectivesFeature([i1.Bind]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c3,
      decls: 7,
      vars: 12,
      consts: [["escapeOut", ""], [3, "pBind"], [3, "pBind", "class"], ["pRipple", "", "type", "button", 3, "pBind", "class"], [4, "ngTemplateOutlet"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngIf", "ngIfElse"], [3, "pBind", "ngClass"], [3, "pBind", "ngClass", "innerHTML", 4, "ngIf"], [3, "pBind", "ngClass", "innerHTML"], [3, "pBind", "ngClass", 4, "ngIf"], ["pRipple", "", "type", "button", 3, "click", "pBind"], [3, "pBind", "class", "ngClass"], ["data-p-icon", "times", 3, "pBind", "class"], ["data-p-icon", "times", 3, "pBind"]],
      template: function Message_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 1)(1, "div", 1);
          i0.ɵɵconditionalCreate(2, Message_Conditional_2_Template, 1, 1, "ng-container");
          i0.ɵɵconditionalCreate(3, Message_Conditional_3_Template, 1, 4, "i", 2);
          i0.ɵɵconditionalCreate(4, Message_Conditional_4_Template, 1, 4, "ng-container")(5, Message_Conditional_5_Template, 5, 5);
          i0.ɵɵconditionalCreate(6, Message_Conditional_6_Template, 4, 8, "button", 3);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.cx("contentWrapper"));
          i0.ɵɵproperty("pBind", ctx.ptm("contentWrapper"));
          i0.ɵɵattribute("data-p", ctx.dataP);
          i0.ɵɵadvance();
          i0.ɵɵclassMap(ctx.cx("content"));
          i0.ɵɵproperty("pBind", ctx.ptm("content"));
          i0.ɵɵattribute("data-p", ctx.dataP);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.iconTemplate || ctx._iconTemplate ? 2 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.icon ? 3 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.containerTemplate || ctx._containerTemplate ? 4 : 5);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.closable ? 6 : -1);
        }
      },
      dependencies: [CommonModule, i2.NgClass, i2.NgIf, i2.NgTemplateOutlet, TimesIcon, Ripple, SharedModule, Bind, MotionModule],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return Message;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MessageModule = /*#__PURE__*/(() => {
  class MessageModule {
    static ɵfac = function MessageModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MessageModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MessageModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [Message, SharedModule, SharedModule]
    });
  }
  return MessageModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Message, MessageClasses, MessageModule, MessageStyle };
